import { Checkbox, CheckboxState as C } from "react-migration/components/DeprecatedCheckbox";
import { Theme } from "react-migration/lib/theme/Theme";
import { FC } from "react";
import { TenureTypes } from "react-migration/domains/comparables/typings/Tenure";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { HMLRTenureShorthandGQL } from "react-migration/lib/typings/comparables/HMLR";
import { HometrackTenureShorthandGQL } from "react-migration/lib/typings/comparables/Hometrack";

// hometrackV2: Delete "ANY" when beta gone
type TenureShorthandGQL = "Any" | HMLRTenureShorthandGQL | HometrackTenureShorthandGQL;

const TENURE_LABEL_KEYS: Record<TenureTypes, string> = {
  // hometrackV2: Delete when beta gone
  [TenureTypes.ANY]: "comparables.map.sidebar.filters.filters.tenure.any",
  [TenureTypes.FREEHOLD]: "comparables.map.sidebar.filters.filters.tenure.freehold",
  [TenureTypes.LEASEHOLD]: "comparables.map.sidebar.filters.filters.tenure.leasehold",
  [TenureTypes.SHARED]: "comparables.map.sidebar.filters.filters.tenure.shared",
};

export interface FilterTenureProps {
  disabled?: boolean;
  tenureTypes: Array<TenureShorthandGQL>;
  setTenureTypes: (values: Array<TenureShorthandGQL>) => void;
  availableTenures: TenureTypes[];
  theme?: Theme;
}

function toggleTenureType(
  currentTypes: Array<TenureShorthandGQL>,
  toggledOption: TenureShorthandGQL
): Array<TenureShorthandGQL> {
  const index = currentTypes.indexOf(toggledOption);

  if (index >= 0) {
    return currentTypes.filter((type) => type !== toggledOption);
  } else {
    return [...currentTypes, toggledOption];
  }
}

export const FilterTenure: FC<FilterTenureProps> = ({
  disabled,
  tenureTypes,
  setTenureTypes,
  availableTenures,
  theme = Theme.Light,
}) => {
  const { t } = useTranslation();

  const updateTenureType = (type: TenureShorthandGQL) => {
    setTenureTypes(toggleTenureType(tenureTypes, type));
  };

  const disabledTextColor = `text-text-base-primary-disabled-${theme === Theme.Light ? "light" : "dark"}`;

  return (
    <div data-testid="filter-tenure">
      <h4 className={`my-2 ${disabled ? disabledTextColor : ""}`}>
        {t("comparables.map.sidebar.filters.filters.tenure.label")}
      </h4>
      <div className="flex flex-col gap-2 font-bold">
        {availableTenures.map((tenureType) => (
          <div className="flex gap-1" key={tenureType}>
            <Checkbox
              disabled={disabled}
              id={`tenure-${tenureType.toLowerCase()}`}
              value={tenureTypes.includes(tenureType) ? C.CHECKED : C.EMPTY}
              onChange={() => updateTenureType(tenureType)}
              theme={theme}
            />
            <label className={`pl-1 ${disabled ? disabledTextColor : ""}`}>{t(TENURE_LABEL_KEYS[tenureType])}</label>
          </div>
        ))}
      </div>
    </div>
  );
};
